<!-- 班级 -->
<template>
    <div>
      <div class="course_classInfo">
        <el-row>
          <!-- <el-col :span="5">
            <el-row style="overflow: auto;border: 1px solid #DEDEDE;margin-right: 20px;min-height:400px;height: calc(100vh - 460px);">
              <TitleInfo title="班级筛选" :titleImg="geren" bgClose="#EFF2F7;" :showClose="false"></TitleInfo>
              <div class="block p20">
                <el-tree
                  :data="data"
                  node-key="id"
                  default-expand-all
                  :expand-on-click-node="false">
                  <span class="custom-tree-node" style="width: 100%;" slot-scope="{ node, data }">
                    <span style="margin-right: 50px;">{{ node.label }}</span>
                    <span style="float: right;">
                      <el-button
                        type="text"
                        size="mini"
                        @click="() => remove(node, data)">
                        <i class="el-icon-delete"></i>
                      </el-button>
                    </span>
                    <span style="float: right;margin-right: 20px;" v-if="data.id == 1">
                      <el-button
                        type="text"
                        size="mini"
                        @click="() => append(data)">
                        <i class="el-icon-plus"></i>
                      </el-button>
                    </span>
                  </span>
                </el-tree>
              </div>
            </el-row>
          </el-col> -->
          <el-col :span="24">
            <el-row>
              <el-input v-model="searchInfo" clearable style="width: 200px;" prefix-icon="el-icon-search" placeholder="请输入学号或姓名"></el-input>
              <label style="margin-left: 20px;">班级：</label>
              <el-select clearable v-model="value" filterable placeholder="请选择">
                <template v-for="(item ,index) in classList">
                  <el-option :label="item.schoolClassIdText" :value="item.schoolClassId"></el-option>
                </template>
              </el-select>
              <el-button type="primary" icon="el-icon-search" @click="getInfo(page = 1)">搜索</el-button>
              <el-button type="success" icon="el-icon-plus" @click="addStudent">添加学生</el-button>
              <el-button type="success" icon="el-icon-plus" @click="addClass">添加开课班级</el-button>
              <el-button icon="el-icon-s-grid" @click="openGroupDialog">课程小组管理</el-button>
            </el-row>
            <el-row class="content_block mt20">
              <el-row>
                <el-table
                  :data="displayTableData"
                  border
                  style="width: 100%">
                  <el-table-column prop="studentIdText" header-align="center" align="center" label="姓名">
                    <template slot-scope="scope">
                      {{scope.row.studentIdText || scope.row.studentInfo.studentName}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="studentInfo.studentSn" header-align="center" align="center" label="学号"> </el-table-column>
                  <el-table-column prop="studentInfo.classIdText" header-align="center" align="center" label="归属班级"> </el-table-column>
                  <el-table-column prop="studentInfo.schoolClass.universitySystemIdText" header-align="center" align="center" label="归属专业"> </el-table-column>
                  <el-table-column prop="teacherOpenCourseSchoolClassMergeStudentAddTime" header-align="center" align="center" label="添加时间"> </el-table-column>
                  <el-table-column prop="groupName" header-align="center" align="center" label="组别" width="100">
                    <template slot-scope="scope">
                      <span v-if="groupNameOf(scope.row)">{{groupNameOf(scope.row)}}</span>
                      <span v-else class="gm_td_empty">-</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="cz_" header-align="center" align="center" label="操作">
                    <template slot-scope="scope">
                      <el-link type="danger" class="mr20" :underline="false" @click="delInfo(scope.row)">删除</el-link>
                      <el-link type="primary" :underline="false" @click="editPas(scope.row)">重置密码</el-link>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="block" style="text-align: right;bottom: 0;width: 96%;margin: 20px;">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="page"
                    :page-sizes="[8, 20, 50, 100]"
                    :page-size="limit"
                    background
                    :hide-on-single-page="false"
                    layout="sizes, prev, pager, next,jumper"
                    :total="displayTotal">
                  </el-pagination>
                </div>
              </el-row>
            </el-row>
          </el-col>
        </el-row>

        <!-- ==================== 课程小组管理 ==================== -->
        <el-dialog
          class="gm_dialog"
          :visible.sync="groupDialogShow"
          width="92%"
          top="5vh"
          :close-on-click-modal="false">
          <div slot="title" class="gm_dlg_head">
            <div class="gm_dlg_title">
              <p class="gm_dlg_name">课程小组管理</p>
              <p class="gm_dlg_sub">智能分组后，拖动学生名字即可更换小组</p>
            </div>
            <div class="gm_dlg_stats">
              <div class="gm_stat">
                <b>{{studentPool.length}}</b>
                <span>总人数</span>
              </div>
              <div class="gm_stat">
                <b>{{groupedCount}}</b>
                <span>已分组</span>
              </div>
              <div class="gm_stat" :class="{'is-warn': ungroupedList.length > 0}">
                <b>{{ungroupedList.length}}</b>
                <span>未分组</span>
              </div>
              <div class="gm_stat">
                <b>{{groupList.length}}</b>
                <span>小组数</span>
              </div>
            </div>
          </div>

          <!-- 分组方式 -->
          <div class="gm_mode_bar">
            <span class="gm_mode_label">分组方式</span>
            <el-radio-group v-model="groupMode" size="small">
              <el-radio-button label="count">按组数</el-radio-button>
              <el-radio-button label="size">按每组人数</el-radio-button>
              <el-radio-button label="class">按行政班分组</el-radio-button>
            </el-radio-group>

            <template v-if="groupMode === 'count'">
              <el-input-number
                class="gm_num"
                v-model="groupCount"
                size="small"
                :min="1"
                :max="60">
              </el-input-number>
              <span class="gm_unit">组</span>
            </template>
            <template v-else>
              <el-input-number
                class="gm_num"
                v-model="groupSizeLimit"
                size="small"
                :min="1"
                :max="200">
              </el-input-number>
              <span class="gm_unit">{{groupMode === 'class' ? '人 / 组上限' : '人 / 组'}}</span>
            </template>

            <template v-if="groupMode !== 'class'">
              <el-button type="primary" size="small" icon="el-icon-magic-stick" @click="autoGroup('smart')">智能分组</el-button>
              <el-button size="small" icon="el-icon-refresh" @click="autoGroup('random')">随机</el-button>
            </template>
            <el-button v-else type="primary" size="small" icon="el-icon-magic-stick" @click="autoGroupByClass">按行政班分组</el-button>

            <el-button type="text" size="small" class="gm_clear" @click="clearGroups">
              <i class="el-icon-delete"></i> 清空
            </el-button>

            <el-button class="gm_add_btn" size="small" icon="el-icon-plus" @click="addGroup">新增小组</el-button>
          </div>

          <!-- 未分组学生 -->
          <div
            class="gm_ungroup"
            v-if="ungroupedList.length > 0"
            :class="{'is-drag-over': dragOverPool}"
            @dragover.prevent="onDragOverUngroup"
            @dragleave="dragOverPool = false"
            @drop.prevent="dropToUngrouped">
            <span class="gm_ungroup_label">
              <i class="el-icon-rank"></i> 未分组 {{ungroupedList.length}} 人
            </span>
            <span class="gm_pool_hint">拖到此处 = 移出小组</span>
            <div class="gm_chips">
              <span
                class="gm_chip"
                v-for="stu in ungroupedList"
                :key="stu.studentId"
                draggable="true"
                :class="{'is-dragging': isDragging(stu)}"
                @dragstart="onDragStart($event, stu, '')"
                @dragend="onDragEnd">
                <span class="gm_chip_name">{{stu.studentName}}</span>
                <span class="gm_chip_cls">{{stu.classIdText}}</span>
              </span>
            </div>
          </div>

          <!-- 空态引导卡（对照设计稿）：还没有分组时给一键智能分组入口 -->
          <div class="gm_empty_guide" v-if="groupList.length === 0">
            <div class="gm_guide_icon"><i class="el-icon-user"></i></div>
            <p class="gm_guide_title">还没有分组</p>
            <p class="gm_guide_desc">
              <template v-if="groupMode === 'count'">设好<b>{{groupCount}}</b> 组，一键智能分组<br>每组会自动混合不同行政班的学生，之后可拖拽微调</template>
              <template v-else-if="groupMode === 'size'">设好每组<b>{{groupSizeLimit}}</b> 人，一键智能分组<br>每组会自动混合不同行政班的学生，之后可拖拽微调</template>
              <template v-else>按行政班一键分组<br>同一班级的学生自动归到同一组，之后可拖拽微调</template>
            </p>
            <el-button type="primary" icon="el-icon-magic-stick" @click="autoGroup('smart')">一键智能分组</el-button>
          </div>

          <!-- 小组卡片 -->
          <div class="gm_grid">
            <div
              class="gm_card"
              v-for="(g, gi) in groupList"
              :key="g.groupId"
              :class="{'is-drag-over': dragOverGroupId === g.groupId}"
              @dragover.prevent="onDragOverGroup(g)"
              @drop.prevent="onDropGroup(g)">
              <div class="gm_card_head">
                <span class="gm_num_badge">{{gi + 1}}</span>
                <span class="gm_card_title">第{{gi + 1}}组</span>
                <span class="gm_card_count">{{g.members.length}} 人</span>
                <span class="gm_card_del" title="删除该组" @click="deleteGroup(g)">
                  <i class="el-icon-close"></i>
                </span>
              </div>
              <div class="gm_card_body">
                <div
                  class="gm_member"
                  v-for="(m, mi) in g.members"
                  :key="m.studentId"
                  draggable="true"
                  :class="{
                    'is-dragging': isDragging(m),
                    'is-drop-target': dragOverMemberKey === (g.groupId + '_' + m.studentId)
                  }"
                  @dragstart="onDragStart($event, m, g.groupId)"
                  @dragend="onDragEnd"
                  @dragover.stop.prevent="onDragOverMember(g, m)"
                  @drop.stop.prevent="onDropMember(g, m, mi)">
                  <span class="gm_grip"><i class="el-icon-rank"></i></span>
                  <span class="gm_avatar" :class="'c' + colorOf(m)">{{firstChar(m.studentName)}}</span>
                  <span class="gm_member_name">{{m.studentName}}</span>
                  <span class="gm_member_cls" v-if="showClass(m)">{{m.classIdText}}</span>
                  <span
                    class="gm_member_star"
                    :class="{'is-leader': m.isLeader}"
                    :title="m.isLeader ? '取消组长' : '设为组长'"
                    @click.stop="setLeader(g, m)">
                    <i :class="m.isLeader ? 'el-icon-star-on' : 'el-icon-star-off'"></i>
                  </span>
                  <span class="gm_member_del" title="移出小组" @click.stop="removeMember(g, mi)">
                    <i class="el-icon-close"></i>
                  </span>
                </div>
                <p class="gm_card_empty" v-if="g.members.length === 0">拖动学生到此处</p>
              </div>
            </div>

            <div class="gm_add_card" @click="addGroup">
              <i class="el-icon-plus"></i>
              <span>新增小组</span>
            </div>
          </div>

          <div slot="footer" class="gm_dlg_foot">
            <span class="gm_dirty" :class="{'is-dirty': groupDirty}">
              <i class="el-icon-warning-outline"></i>
              {{groupDirty ? '有未保存的修改，点击【保存分组】同步到名单' : '当前分组已与名单一致'}}
            </span>
            <div class="gm_dlg_btns">
              <el-button size="small" @click="cancelGroupDialog">取 消</el-button>
              <el-button size="small" type="primary" icon="el-icon-check" @click="saveGroups">保存分组</el-button>
            </div>
          </div>
        </el-dialog>

        <!-- 添加学生信息 -->
        <el-dialog
          title="添加开课学生"
          :visible.sync="addStudentShow"
          width="700px"
        >
          <span slot="title">
            <i class="el-icon-user" style="margin-right: 10px;color: #f9c75a;"></i>添加开课学生
          </span>
          <el-row class="mb20">
            <el-input v-model="studentOrName" style="width: 200px;" prefix-icon="el-icon-search" placeholder="请输入学号或姓名"></el-input>
            <el-button type="primary" icon="el-icon-search" @click="getSutdentList(page_stu = 1)">搜索</el-button>
          </el-row>
          <el-table
            :data="tableStudent"
            border
            ref="multipleTable"
            max-height="300px"
            style="width: 100%">
            <el-table-column type="selection" header-align="center" align="center" width="55"></el-table-column>
            <el-table-column prop="studentName" label="姓名" header-align="center" align="center" width="100"></el-table-column>
            <el-table-column prop="studentSn" label="学号" header-align="center" align="center" width="120"></el-table-column>
            <el-table-column prop="classIdText" label="班级" header-align="center" align="center"></el-table-column>
            <el-table-column prop="schoolClass.universitySystemIdText" label="专业" header-align="center" align="center"></el-table-column>
          </el-table>
          <div class="block" style="text-align: right;bottom: 0;width: 96%;margin: 20px;">
            <el-pagination
              @size-change="handleSizeChange_stu"
              @current-change="handleCurrentChange_stu"
              :current-page.sync="page_stu"
              :page-sizes="[8, 20, 50, 100]"
              :page-size="limit_stu"
              background
              :pager-count="5"
              :hide-on-single-page="false"
              layout="sizes, prev, pager, next,jumper"
              :total="total_stu">
            </el-pagination>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="addStudentShow = false">取 消</el-button>
            <el-button type="primary" @click="submitAddStudent">确 认</el-button>
          </span>
        </el-dialog>

        <!-- 添加开课班级 -->
        <el-dialog
          title="添加开课班级"
          class="el-dialog_class"
          :visible.sync="addClassShow"
          width="700px"
        >
          <span slot="title">
            <i class="el-icon-user" style="margin-right: 10px;color: #f9c75a;"></i>添加开课班级
          </span>
          <el-row>
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
            <div style="margin: 10px 0;"></div>
            <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
              <el-checkbox v-for="city in schoolClassList" :label="city.classId" :key="city.classId">
                {{city.className}}
              </el-checkbox>
            </el-checkbox-group>
          </el-row>
          <span slot="footer" class="dialog-footer">
            <el-button @click="addClassShow = false">取 消</el-button>
            <el-button type="primary" @click="submitAddClass">确 认</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
</template>
<script>
import TitleInfo from "@/components/TitleInfo"; //页面头部
import {getClassInfo} from "@/common/getInfo"; //加载数据
let id = 1000;
export default {
  name: 'ClassInfo',
  components: {
  	TitleInfo,
  },
  props: {
    courseId: { //课程ID
      type: String,
      required:true
    }
  },
  data() {
    return {
      geren:require("../../../images/asset/geren@2x.png"),
      data:[{
        id: 1,
        label: '全部班级',
        children: [
          {id: 2,label: '天择一班'},
          {id: 3,label: '天择二班'},
          {id: 4,label: '天择三班'},
          {id: 5,label: '天择四班'},
        ]
      }],
      classList:[],
      value: '',
      searchInfo:"",
      tableData:[],

      total: 0,
      limit:8,
      page:1,
      addClassShow:false,
      addStudentShow:false,
      studentOrName:"",
      tableStudent:[],
      total_stu: 0,
      limit_stu:8,
      page_stu:1,
      universitySystemId:this.$ls.get(this.$getKeyInfo("identityInfo")).universitySystemId, //专业ID
      schoolClassList:[], //根据咱也ID查询出来的班级信息
      checkAll: false,
      checkedCities: [],
      isIndeterminate: false,

      // ==================== 课程小组 ====================
      groupDialogShow: false, //课程小组管理弹窗
      studentPool: [], //本课程全部学生（分组数据源）
      groupList: [], //当前编辑中的小组：{groupId, members:[{studentId, studentName, studentSn, classIdText, isLeader}]}
      groupSnapshot: "", //打开弹窗时的分组快照，用于取消回滚与脏检查
      groupSaved: false, //是否已保存过分组（保存后学生名单展示组别列）
      groupMode: "count", //分组方式：count 按组数 / size 按每组人数 / class 按行政班分组
      groupCount: 6, //按组数：目标组数
      groupSizeLimit: 6, //按每组人数：每组人数；按行政班分组：每组人数上限
      groupSeed: 0, //本地小组ID自增种子
      dragging: null, //当前拖拽 {studentId, fromGroupId, stu}，fromGroupId 为空表示来自未分组池
      dragOverGroupId: "", //拖拽悬停的小组
      dragOverMemberKey: "", //拖拽悬停在某个成员行时的落点标识
      dragOverPool: false //拖拽悬停在未分组区
    }
  },
  computed: {
    //未分组学生
    ungroupedList() {
      let used = {};
      this.groupList.forEach(g => {
        g.members.forEach(m => {
          used[String(m.studentId)] = true;
        });
      });
      return this.studentPool.filter(s => !used[String(s.studentId)]);
    },
    //已分组人数
    groupedCount() {
      return this.groupList.reduce((sum, g) => sum + g.members.length, 0);
    },
    //是否有未保存的改动
    groupDirty() {
      return JSON.stringify(this.groupList) !== (this.groupSnapshot || "[]");
    },
    //学生ID -> 组别信息（仅保存后生效）
    groupAssignMap() {
      let map = {};
      if (!this.groupSaved) return map;
      this.groupList.forEach((g, gi) => {
        g.members.forEach(m => {
          map[String(m.studentId)] = { index: gi, name: "第" + (gi + 1) + "组" };
        });
      });
      return map;
    },
    //保存分组后：整份名单按组别顺序重排（未分组排最后，同组内按学号）
    groupedRows() {
      if (!this.groupSaved) return [];
      let kw = (this.searchInfo || "").trim();
      let rows = this.studentPool
        .filter(s => s.raw)
        .map(s => s.raw)
        .filter(r => {
          let info = r.studentInfo || {};
          if (this.value && String(info.classId) !== String(this.value)) return false;
          if (kw) {
            let name = r.studentIdText || info.studentName || "";
            let sn = info.studentSn || "";
            if (String(name).indexOf(kw) < 0 && String(sn).indexOf(kw) < 0) return false;
          }
          return true;
        });
      let map = this.groupAssignMap;
      rows.sort((a, b) => {
        let ga = map[String(a.studentId)];
        let gb = map[String(b.studentId)];
        let ia = ga ? ga.index : 9999;
        let ib = gb ? gb.index : 9999;
        if (ia !== ib) return ia - ib;
        let sa = (a.studentInfo && a.studentInfo.studentSn) || "";
        let sb = (b.studentInfo && b.studentInfo.studentSn) || "";
        return String(sa).localeCompare(String(sb));
      });
      return rows;
    },
    //表格数据：未保存分组时走后端分页，保存后走前端组别排序
    displayTableData() {
      if (!this.groupSaved) return this.tableData;
      let start = (this.page - 1) * this.limit;
      return this.groupedRows.slice(start, start + this.limit);
    },
    //表格总数
    displayTotal() {
      return this.groupSaved ? this.groupedRows.length : this.total;
    }
  },
  created() {
    this.getInfo();
    this.getClassList();
    this.getCourseGroups();
    this.getStudentPool(); //页面加载即拉全量学生池（分组数据源 + 名单按组排序依赖），不等打开弹窗才调
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.getInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },handleSizeChange_stu(val) {
      console.log(`每页 ${val} 条`);
      this.limit_stu = val;
      this.getSutdentList();
    },
    handleCurrentChange_stu(val) {
      console.log(`当前页: ${val}`);
      this.page_stu = val;
      this.getSutdentList();
    },
    getInfo(){ //获取数据
      let param = {
        limit:this.limit,
        page:this.page,
        studentOrName:this.searchInfo,
        studentSnOrName:this.searchInfo,
        schoolClassId:this.value,
        teacherOpenCourseId:this.courseId
      }
      this.$post("/api/teacherOpenCourseMergeStudent/getPageList.do",param).then((ret) =>{
        if(ret.code == 0){
          this.total = Number(ret.count);
          this.tableData = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    getClassList(){
      getClassInfo({teacherOpenCourseId:this.courseId}).then(ret =>{ //根据课程ID获取班级信息
        if(ret.code == 0){
          this.classList = ret.data;
        }
      });
    },
    getSutdentList(){
      let param = {
        limit:this.limit_stu,
        page:this.page_stu,
        studentOrName:this.studentOrName,
        studentSnOrName:this.studentOrName,
        teacherOpenCourseId:this.courseId,
        universitySystemId:this.universitySystemId
      }
      /**
       * 这里接口是没问题的，就是要访问学生列表。
       */
      this.$post("/api/student/getPageList.do",param).then((ret) =>{
        if(ret.code == 0){
          this.total_stu = Number(ret.count);
          this.tableStudent = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    addStudent(){ //添加学生信息
      this.getSutdentList();
      this.addStudentShow = true;
    },
    submitAddStudent(){ //提交学生添加信息
      let addStudentList = this.$refs.multipleTable.selection,
          list = new Array(); //获取选中的数据
      if(addStudentList.length <=0){
        this.$message({message: '请选择需要添加的学生！',type: 'warning'});
        return;
      }
      for(let i in addStudentList){
        list.push({
          studentId:addStudentList[i].studentId,
          teacherOpenCourseId:this.courseId
        });
      }
      this.$post("/jlw/teacherOpenCourseMergeStudent/addAll.json",{teacherOpenCourseMergeStudentJsonStr:JSON.stringify(list)}).then((ret) =>{
        if(ret.code == 0){
          this.getInfo();
          this.$message({type: 'success',message: '添加成功！'});
          this.addStudentShow = false;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    // append(data) {
    //   const newChild = { id: id++, label: 'testtest', children: [] };
    //   if (!data.children) {
    //     this.$set(data, 'children', []);
    //   }
    //   data.children.push(newChild);
    // },
    // remove(node, data) {
    //   const parent = node.parent;
    //   const children = parent.data.children || parent.data;
    //   const index = children.findIndex(d => d.id === data.id);
    //   children.splice(index, 1);
    // },
    delInfo(item){ //删除信息
      this.$confirm('是否确定删除学生信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$post("/api/teacherOpenCourseMergeStudent/delete.do",{ids:item.teacherOpenCourseSchoolClassMergeStudentId}).then((ret)=>{
          if(ret.code == 0){
            this.getInfo();
            this.$message({type: 'success',message: '删除成功！'});
            this.removeStudentFromGroups(item.studentId); //同步从分组里移除，避免留下不在名单里的成员
            if (this.groupSaved) this.getStudentPool();
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    editPas(item){ //重置密码
      this.$confirm('是否确定重置密码?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$post("/api/teacherOpenCourseMergeStudent/resetPassword.do",{studentId:item.studentId}).then((ret) =>{
          if(ret.code == 0){
            this.$message({type: 'success',message: '密码重置成功！'});
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    addClass(){ //添加开课班级
      this.getClass();
      this.checkAll = false;
      this.checkedCities = [];
      this.isIndeterminate = false;
      this.addClassShow = true;
    },
    submitAddClass(){ //提交开课班级
      if(this.checkedCities.length <= 0){
        this.$message({message: '请选择需要开课的班级！',type: 'warning'});
        return;
      }
      let list = new Array(); //获取选中的数据
      for(let i in this.checkedCities){
        list.push({
          schoolClassId:this.checkedCities[i],
          teacherOpenCourseId:this.courseId
        });
      }
      this.$post("/jlw/teacherOpenCourseMergeSchoolClass/addAll.json",{teacherOpenCourseMergeSchoolClassJsonStr:JSON.stringify(list)}).then((ret) =>{
        if(ret.code == 0){
          this.getInfo();
          this.getClassList();
          this.$message({type: 'success',message: '添加成功！'});
          this.addClassShow = false;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });

    },
    getClass(){ //获取班级信息
      // if(this.$isEmpty(this.universitySystemId)){
      //   this.$message({message: '数据丢失，请重试！',type: 'warning'});
      //   return;
      // }
      this.$get("/jlw/schoolClass/getValues.json",{universitySystemId:this.universitySystemId}).then((ret) =>{
        if(ret.code == 0){
          this.schoolClassList = ret.data;
        }
      });
    },
    handleCheckAllChange(val) {
      this.checkedCities = [];
      if(val){
        for(let i in this.schoolClassList){
          this.checkedCities.push(this.schoolClassList[i].classId)
        }
      }
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.schoolClassList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.schoolClassList.length;
    },

    /* ==================== 课程小组 ==================== */
    getCourseGroups() { //查询课程分组（后端接口 getList.do）：分组以后端为唯一数据源
      this.$post("/api/teacherOpenCourseMergeStudentGroup/getList.do", {
        teacherOpenCourseId: this.courseId
      }).then(ret => {
        if (ret.code == 0) {
          let list = ret.data || [];
          let invalidLeaders = []; //组长已失效的组（文档 A2：leaderStudentId 仍回显但 students 中无此人，前端据此提示）
          this.groupList = list.map(g => {
            let members = (g.students || []).map(s => {
              return {
                studentId: s.studentId,
                studentName: s.studentName,
                studentSn: s.studentSn,
                classIdText: s.classIdText,
                isLeader: String(s.studentId) === String(g.leaderStudentId)
              };
            });
            if (!this.$isEmpty(g.leaderStudentId) && members.every(m => String(m.studentId) !== String(g.leaderStudentId))) {
              invalidLeaders.push(g.groupName || "");
            }
            return {
              groupId: "g_" + ++this.groupSeed, //前端展示用临时 key（拖拽/列表 key），非后端小组 ID
              serverGroupId: g.groupId || "", //后端若返回小组 ID 则保留（前向兼容，供按小组发布作业使用）
              serverGroupName: g.groupName || "",
              members: members
            };
          });
          if (invalidLeaders.length > 0) {
            this.$message({ message: "以下小组的组长已不在课程中，请重新设置组长：" + invalidLeaders.join("、"), type: "warning", duration: 5000 });
          }
          if (list.length > 0) {
            this.groupSaved = true;
            this.groupSnapshot = JSON.stringify(this.groupList);
          }
        }
      }).catch(() => {});
    },
    openGroupDialog() { //打开课程小组管理弹窗
      this.groupSnapshot = JSON.stringify(this.groupList);
      this.groupDialogShow = true;
      if (this.studentPool.length === 0) this.getStudentPool();
    },
    getStudentPool(silent) { //本课程全部学生，作为分组数据源（复用学生名单接口）；silent=初始加载时不弹空提示
      let param = {
        limit: 999,
        page: 1,
        studentOrName: "",
        studentSnOrName: "",
        schoolClassId: "",
        teacherOpenCourseId: this.courseId
      };
      this.$post("/api/teacherOpenCourseMergeStudent/getPageList.do", param).then(ret => {
        if (ret.code == 0) {
          this.studentPool = (ret.data || []).map(item => {
            let info = item.studentInfo || {};
            return {
              studentId: item.studentId || item.teacherOpenCourseSchoolClassMergeStudentId,
              studentName: item.studentIdText || info.studentName || "-",
              studentSn: info.studentSn || "-",
              classId: info.classId || "",
              classIdText: info.classIdText || "",
              raw: item
            };
          });
          if (this.studentPool.length === 0 && !silent) {
            this.$message({ message: "当前课程还没有学生，请先在学生名单里添加学生", type: "warning" });
          }
        } else {
          this.$message({ message: ret.msg, type: "error" });
        }
      });
    },
    toMember(stu) { //学生池对象转小组成员
      return {
        studentId: stu.studentId,
        studentName: stu.studentName,
        studentSn: stu.studentSn,
        classIdText: stu.classIdText,
        isLeader: false
      };
    },
    firstChar(name) { //取姓名首字做头像文字
      let s = String(name || "").trim();
      return s ? s.charAt(0) : "?";
    },
    colorOf(stu) { //按学生ID生成稳定配色，同一学生在任何位置颜色一致
      let id = String((stu && stu.studentId) || "");
      let sum = 0;
      for (let i = 0; i < id.length; i++) sum += id.charCodeAt(i);
      return sum % 6;
    },
    showClass(m) { //行政班字段无效时不显示标签，避免出现「未分组」这类矛盾文案
      let c = String((m && m.classIdText) || "").trim();
      if (!c) return false;
      return ["未分组", "未分班", "-", "—"].indexOf(c) === -1;
    },
    newGroup(members) { //新建一个小组结构
      return { groupId: "g_" + ++this.groupSeed, members: members || [] };
    },
    groupNameOf(row) { //名单表格中该学生所属组别
      let g = this.groupAssignMap[String(row.studentId)];
      return g ? g.name : "";
    },
    addGroup() { //新增空小组
      this.groupList.push(this.newGroup([]));
    },
    deleteGroup(group) { //删除小组，组内学生回到未分组
      let idx = this.groupList.indexOf(group);
      if (idx < 0) return;
      this.$confirm("确定删除第 " + (idx + 1) + " 组吗？组内学生将回到未分组。", "提示", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.groupList.splice(idx, 1);
      }).catch(() => {});
    },
    clearGroups() { //清空分组结果
      if (this.groupList.length === 0) {
        this.$message({ message: "当前没有分组结果", type: "info" });
        return;
      }
      this.$confirm("确定清空全部分组吗？所有学生将回到未分组。", "提示", {
        confirmButtonText: "清空",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.groupList = [];
        this.groupSaved = false;
        //同步清掉 sessionStorage 里的分组摘要，避免按小组发布作业读到旧数据
        try {
          this.$ls.set(this.$getKeyInfo("courseGroups_" + this.courseId), []);
        } catch (e) {}
        //后端整体覆盖：groups 传空数组 = 清空该课程全部分组
        this.$postJSON("/api/teacherOpenCourseMergeStudentGroup/save.do", {
          teacherOpenCourseId: this.courseId,
          groups: []
        }).catch(() => {});
        this.$message({ message: "已清空分组结果", type: "success" });
      }).catch(() => {});
    },
    removeMember(group, index) { //把成员移出小组
      group.members.splice(index, 1);
      this.ensureLeader(group);
    },
    setLeader(group, member) { //设为/取消组长
      if (member.isLeader) {
        member.isLeader = false;
        return;
      }
      group.members.forEach(m => {
        m.isLeader = false;
      });
      member.isLeader = true;
    },
    ensureLeader(group) { //保证有成员的组里恰好有一位组长
      if (group.members.length === 0) return;
      let leaders = group.members.filter(m => m.isLeader);
      if (leaders.length === 1) return;
      group.members.forEach(m => {
        m.isLeader = false;
      });
      group.members[0].isLeader = true;
    },
    splitByClass(list) { //按行政班拆桶，人数多的班排前面
      let map = {};
      let keys = [];
      list.forEach(s => {
        let k = s.classIdText || "未分班";
        if (!map[k]) {
          map[k] = [];
          keys.push(k);
        }
        map[k].push(s);
      });
      return keys
        .map(k => {
          return { key: k, list: map[k] };
        })
        .sort((a, b) => b.list.length - a.list.length);
    },
    autoGroup(method) { //自动分组：method 为 smart 智能分组（混合行政班）/ random 纯随机
      if (this.studentPool.length === 0) {
        this.$message({ message: "当前课程还没有学生，无法分组", type: "warning" });
        return;
      }
      let total = this.studentPool.length;
      let count = this.groupMode === "count"
        ? Number(this.groupCount)
        : Math.ceil(total / Math.max(1, Number(this.groupSizeLimit) || 1));
      if (!count || count < 1) {
        this.$message({ message: "请填写有效的分组数量", type: "warning" });
        return;
      }
      if (count > total) {
        this.$message({ message: "小组数量不能超过学生总数（" + total + " 人）", type: "warning" });
        return;
      }
      let run = () => {
        let groups = [];
        for (let i = 0; i < count; i++) groups.push(this.newGroup([]));
        if (method === "random") {
          //纯随机：打乱后轮流分配
          let list = this.studentPool.slice().sort(() => Math.random() - 0.5);
          list.forEach((s, i) => {
            groups[i % count].members.push(this.toMember(s));
          });
        } else {
          //智能分组：先按行政班轮转交叉排列，再放进当前人数最少的组，保证人数均衡且各组混合不同行政班
          let buckets = this.splitByClass(this.studentPool.slice());
          let list = [];
          let alive = true;
          while (alive) {
            alive = false;
            buckets.forEach(b => {
              if (b.list.length) {
                list.push(b.list.shift());
                alive = true;
              }
            });
          }
          list.forEach(s => {
            let cls = s.classIdText;
            let target = null;
            let targetScore = 0;
            groups.forEach(g => {
              //人数优先（差 1 人加 10 分），同人数时优先选还没有该行政班的组，保证各组混合不同班级
              let hasSameClass = g.members.some(m => m.classIdText === cls) ? 1 : 0;
              let score = g.members.length * 10 + hasSameClass;
              if (target === null || score < targetScore) {
                target = g;
                targetScore = score;
              }
            });
            target.members.push(this.toMember(s));
          });
        }
        groups.forEach(g => {
          if (g.members.length > 0) g.members[0].isLeader = true;
        });
        this.groupList = groups;
      };
      this.confirmOverwrite(run);
    },
    autoGroupByClass() { //按行政班分组：每个班尽量聚在一组，超过人数上限才拆分
      if (this.studentPool.length === 0) {
        this.$message({ message: "当前课程还没有学生，无法分组", type: "warning" });
        return;
      }
      let max = Math.max(1, Number(this.groupSizeLimit) || 1);
      let run = () => {
        let buckets = this.splitByClass(this.studentPool.slice()).sort((a, b) => {
          return String(a.key).localeCompare(String(b.key), "zh");
        });
        let groups = [];
        let cur = [];
        let flush = () => {
          if (cur.length) {
            groups.push(this.newGroup(cur));
            cur = [];
          }
        };
        buckets.forEach(b => {
          //整班放不下时：当前组已过半就先收口；否则让这个班填满当前组，避免留下只有一两个人的小尾巴
          if (cur.length > 0 && cur.length + b.list.length > max && cur.length >= Math.ceil(max / 2)) flush();
          b.list.forEach(s => {
            cur.push(this.toMember(s));
            if (cur.length >= max) flush();
          });
        });
        flush();
        groups.forEach(g => {
          if (g.members.length > 0) g.members[0].isLeader = true;
        });
        this.groupList = groups;
      };
      this.confirmOverwrite(run);
    },
    confirmOverwrite(run) { //重新分组前确认覆盖
      if (this.groupList.length === 0) {
        run();
        return;
      }
      this.$confirm("重新分组会覆盖当前的 " + this.groupList.length + " 个小组，是否继续？", "提示", {
        confirmButtonText: "继续",
        cancelButtonText: "取消",
        type: "warning"
      }).then(run).catch(() => {});
    },
    saveGroups() { //保存分组：调后端整体覆盖接口（save.do），成功后写回名单并关闭弹窗
      let groups = this.groupList.map((g, gi) => {
        let leader = g.members.filter(m => m.isLeader)[0] || g.members[0];
        return {
          name: "第" + (gi + 1) + "组",
          leaderStudentId: leader ? String(leader.studentId) : "",
          studentIds: g.members.map(m => String(m.studentId))
        };
      });
      this.$postJSON("/api/teacherOpenCourseMergeStudentGroup/save.do", {
        teacherOpenCourseId: this.courseId,
        groups: groups
      }).then(ret => {
        if (ret.code == 0) {
          this.groupSaved = true;
          this.groupSnapshot = JSON.stringify(this.groupList);
          //同步一份小组摘要到 sessionStorage，供「按小组发布作业」等跨组件读取
          //groupId：后端 A2 返回的小组 ID（文档 B2 要求 GroupIds 传小组 ID）；后端未返回时为空，发布侧回退用组名
          try {
            let summary = groups.map((g, gi) => {
              return {
                name: g.name,
                groupId: (this.groupList[gi] && this.groupList[gi].serverGroupId) || "",
                studentIds: g.studentIds
              };
            });
            this.$ls.set(this.$getKeyInfo("courseGroups_" + this.courseId), summary);
          } catch (e) {}
          this.groupDialogShow = false;
          this.page = 1;
          this.$message({ message: "分组已保存，学生名单已按组别排序", type: "success" });
        } else {
          this.$message({ message: ret.msg || "分组保存失败", type: "error" });
        }
      }).catch(() => {});
    },
    cancelGroupDialog() { //取消：回滚到打开弹窗时的分组
      try {
        this.groupList = JSON.parse(this.groupSnapshot || "[]");
      } catch (e) {
        this.groupList = [];
      }
      this.groupDialogShow = false;
    },
    isDragging(stu) { //判断该学生是否正被拖拽，用于虚化原位置
      if (!this.dragging || !stu) return false;
      return String(this.dragging.studentId) === String(stu.studentId);
    },
    onDragStart(e, stu, fromGroupId) { //开始拖拽：fromGroupId 为空表示来自未分组区
      this.dragging = {
        studentId: stu.studentId,
        fromGroupId: fromGroupId || "",
        stu: stu
      };
      if (e.dataTransfer) { //Firefox 必须先 setData 才会启动拖拽
        e.dataTransfer.effectAllowed = "move";
        try { e.dataTransfer.setData("text/plain", String(stu.studentId)); } catch (err) {}
      }
    },
    onDragEnd() { //拖拽结束，清理全部临时状态
      this.dragging = null;
      this.dragOverGroupId = "";
      this.dragOverMemberKey = "";
      this.dragOverPool = false;
    },
    onDragOverGroup(group) { //悬停小组卡片
      if (this.dragging) this.dragOverGroupId = group.groupId;
    },
    onDragOverMember(group, member) { //悬停到具体成员行，作为插入落点
      if (!this.dragging) return;
      this.dragOverGroupId = group.groupId;
      this.dragOverMemberKey = group.groupId + "_" + member.studentId;
    },
    onDragOverUngroup() { //悬停未分组区（仅从组里拖出时高亮）
      if (this.dragging && this.dragging.fromGroupId) this.dragOverPool = true;
    },
    dropToUngrouped() { //拖回未分组区：从小组移出
      if (!this.dragging) return;
      if (this.dragging.fromGroupId) {
        this.removeStudentFrom(this.dragging.studentId, this.dragging.fromGroupId);
      }
      this.onDragEnd();
    },
    onDropGroup(group) { //拖到小组卡片：追加到末尾
      if (!this.dragging) return;
      this.moveToGroup(this.dragging, group, group.members.length);
      this.onDragEnd();
    },
    onDropMember(group, member, index) { //拖到某个成员上：插入到该位置
      if (!this.dragging) return;
      this.moveToGroup(this.dragging, group, index);
      this.onDragEnd();
    },
    moveToGroup(drag, group, index) { //把学生移动到目标小组的指定位置
      let stuId = String(drag.studentId);
      let sameGroup = drag.fromGroupId && String(drag.fromGroupId) === String(group.groupId);
      if (sameGroup) { //组内调整顺序
        let from = group.members.findIndex(m => String(m.studentId) === stuId);
        if (from < 0) return;
        let item = group.members.splice(from, 1)[0];
        if (from < index) index--;
        group.members.splice(Math.max(0, index), 0, item);
        this.ensureLeader(group);
        return;
      }
      if (group.members.some(m => String(m.studentId) === stuId)) return; //目标组已有此人，不重复添加
      if (drag.fromGroupId) this.removeStudentFrom(stuId, drag.fromGroupId);
      group.members.splice(Math.max(0, index), 0, this.toMember(drag.stu));
      this.ensureLeader(group);
    },
    removeStudentFrom(studentId, groupId) { //按ID把学生移出指定小组
      let g = this.groupList.find(item => String(item.groupId) === String(groupId));
      if (!g) return;
      let idx = g.members.findIndex(m => String(m.studentId) === String(studentId));
      if (idx > -1) {
        g.members.splice(idx, 1);
        this.ensureLeader(g);
      }
    },
    removeStudentFromGroups(studentId) { //学生被移出课程后，同步从所有小组中移除
      this.groupList.forEach(g => {
        let idx = g.members.findIndex(m => String(m.studentId) === String(studentId));
        if (idx > -1) {
          g.members.splice(idx, 1);
          this.ensureLeader(g);
        }
      });
    }

  }
};
</script>
<style  lang="less">
  .course_classInfo{
    padding: 20px;
    border: 1px solid #DEDEDE;
    .content_block{
      background-color: #ffffff;
      .title_img{
        width: 20px;
      }
      .class_img{
        float: left;margin-right: 10px;
      }
      .echarts_row{
        padding: 20px;
      }
      .block_time{
        display: initial;
        margin-left: 20px;
      }
      .el-calendar__body{
        th{
          border-top: 1px solid #E5E5E5;
          border-left: 1px solid #E5E5E5;
          background-color: #EFF2F7;
        }
        th:last-child{
          border-right: 1px solid #E5E5E5;
        }
      }
    }
    .el-dialog_class{
      .el-checkbox{
        margin: 0 30px 10px 0;
        min-width: 160px;
      }
    }

    /* ==================== 课堂小组 ==================== */
    .ci_switch{
      padding: 0 0 15px 0;
    }
    .gm_empty{
      text-align: center;
      font-size: 13px;
      color: #C0C4CC;
      padding: 16px 0;
      margin: 0;
    }
    .gm_picker{
      max-height: 240px;
      overflow: auto;
      border: 1px solid #EBEEF5;
      border-radius: 4px;
      padding: 10px 14px;
      .el-checkbox{
        display: block;
        margin: 0 0 8px 0;
      }
      .gm_picker_sn{
        font-size: 12px;
        color: #C0C4CC;
        margin-left: 6px;
      }
    }
    /* ==================== 课程小组管理 ==================== */
    .gm_dialog{
      .el-dialog{
        max-width: 1680px;
        height: 90vh;
        min-height: 520px;
        display: flex;
        flex-direction: column;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 18px 52px rgba(0, 0, 0, 0.2);
      }
      .el-dialog__header{
        flex: none;
        padding: 16px 24px;
        border-bottom: 1px solid #EBEEF5;
      }
      .el-dialog__headerbtn{
        top: 18px;
        right: 18px;
        font-size: 18px;
      }
      .el-dialog__body{
        flex: 1;
        min-height: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        color: #303133;
        background-color: #F5F7FA;
      }
      .el-dialog__footer{
        flex: none;
        padding: 12px 24px;
        border-top: 1px solid #EBEEF5;
        background-color: #ffffff;
      }
    }
    .gm_dlg_head{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-right: 30px;
      .gm_dlg_title{
        min-width: 0;
        .gm_dlg_name{
          margin: 0;
          font-size: 17px;
          font-weight: 600;
          color: #1F2D3D;
          line-height: 24px;
          letter-spacing: .3px;
        }
        .gm_dlg_sub{
          margin: 3px 0 0 0;
          font-size: 12px;
          color: #909399;
          line-height: 16px;
          font-weight: normal;
        }
      }
    }
    .gm_dlg_stats{
      flex: none;
      display: flex;
      align-items: center;
      .gm_stat{
        min-width: 68px;
        margin-left: 8px;
        padding: 5px 14px;
        text-align: center;
        border-radius: 6px;
        background-color: #F5F7FA;
        b{
          display: block;
          font-size: 17px;
          font-weight: 600;
          color: #303133;
          line-height: 22px;
        }
        span{
          display: block;
          font-size: 12px;
          color: #909399;
          line-height: 16px;
        }
        &.is-warn{
          background-color: #FDF6EC;
          b{
            color: #E6A23C;
          }
        }
      }
    }
    .gm_mode_bar{
      flex: none;
      display: flex;
      align-items: center;
      padding: 10px 24px;
      border-bottom: 1px solid #EBEEF5;
      background-color: #ffffff;
      .gm_mode_label{
        font-size: 13px;
        font-weight: 500;
        color: #303133;
        margin-right: 12px;
      }
      .gm_num{
        width: 90px;
        margin-left: 12px;
        .el-input__inner{
          padding: 0 26px;
          text-align: center;
        }
      }
      .gm_unit{
        font-size: 13px;
        color: #606266;
        margin: 0 14px 0 6px;
      }
      .el-radio-group{
        margin-right: 4px;
      }
      .el-button{
        margin-left: 8px;
      }
      .gm_clear{
        margin-left: 14px;
        color: #909399;
        font-size: 13px;
        &:hover{
          color: #F56C6C;
        }
      }
      .gm_add_btn{
        margin-left: auto;
      }
    }
    .gm_ungroup{
      flex: none;
      display: flex;
      align-items: flex-start;
      padding: 10px 24px;
      background-color: #F1F8FF;
      border-bottom: 1px solid #DCEDFF;
      transition: background-color .15s;
      .gm_ungroup_label{
        flex: none;
        font-size: 12px;
        color: #5A7CA8;
        line-height: 26px;
        margin-right: 12px;
        i{
          color: #8AB4E0;
        }
      }
      .gm_pool_hint{
        flex: none;
        margin-left: auto;
        font-size: 12px;
        color: #8AB4E0;
        line-height: 26px;
      }
      .gm_chips{
        flex: 1;
        min-width: 0;
        display: flex;
        flex-wrap: wrap;
        max-height: 62px;
        overflow: auto;
      }
      .gm_chip{
        display: inline-flex;
        align-items: center;
        height: 26px;
        padding: 0 10px;
        margin: 0 8px 8px 0;
        border: 1px solid #D6E6F7;
        border-radius: 13px;
        background-color: #ffffff;
        font-size: 12px;
        color: #303133;
        cursor: grab;
        transition: border-color .15s, box-shadow .15s, transform .15s;
        &:hover{
          border-color: #409EFF;
          box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
        }
        &:active{
          cursor: grabbing;
          transform: scale(.98);
        }
        &.is-dragging{
          opacity: .4;
          border-style: dashed;
          border-color: #409EFF;
        }
        .gm_chip_name{
          margin-right: 6px;
        }
        .gm_chip_cls{
          font-size: 12px;
          color: #909399;
        }
      }
      &.is-drag-over{
        background-color: #E3F0FF;
        box-shadow: inset 0 0 0 2px rgba(64, 158, 255, 0.4);
      }
    }
    .gm_empty_guide{
      margin: 40px auto 20px;
      width: 320px;
      padding: 30px 24px;
      text-align: center;
      background-color: #FAFBFD;
      border: 1px dashed #D6E6F7;
      border-radius: 12px;
      .gm_guide_icon{
        width: 56px;
        height: 56px;
        margin: 0 auto 14px;
        border-radius: 14px;
        background-color: #E8F1FF;
        color: #409EFF;
        font-size: 28px;
        line-height: 56px;
      }
      .gm_guide_title{
        margin: 0 0 10px;
        font-size: 15px;
        color: #303133;
        font-weight: bold;
      }
      .gm_guide_desc{
        margin: 0 0 16px;
        font-size: 12px;
        color: #909399;
        line-height: 22px;
        b{
          color: #409EFF;
          padding: 0 2px;
        }
      }
    }
    .gm_grid{
      flex: 1;
      min-height: 0;
      overflow: auto;
      display: grid;
      grid-template-columns: repeat(4, minmax(0, 1fr));
      grid-auto-rows: minmax(180px, max-content);
      align-items: stretch;
      gap: 14px;
      align-content: start;
      padding: 16px 20px 20px 20px;
    }
    .gm_card{
      display: flex;
      flex-direction: column;
      border: 1px solid #EBEEF5;
      border-radius: 8px;
      background-color: #ffffff;
      transition: box-shadow .2s, border-color .2s;
      &:hover{
        border-color: #DCDFE6;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.07);
      }
      &.is-drag-over{
        border-color: #409EFF;
        background-color: #F7FBFF;
        box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
      }
      .gm_card_head{
        flex: none;
        display: flex;
        align-items: center;
        padding: 10px 12px;
        border-bottom: 1px solid #F2F6FC;
        .gm_num_badge{
          flex: none;
          width: 20px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          border-radius: 6px;
          font-size: 12px;
          font-weight: 600;
          color: #ffffff;
          background-color: #409EFF;
          margin-right: 8px;
        }
        .gm_card_title{
          font-size: 13px;
          font-weight: 600;
          color: #1F2D3D;
        }
        .gm_card_count{
          font-size: 12px;
          color: #909399;
          margin-left: 8px;
        }
        .gm_card_del{
          margin-left: auto;
          font-size: 14px;
          color: #C0C4CC;
          cursor: pointer;
          line-height: 1;
          transition: color .15s;
          &:hover{
            color: #F56C6C;
          }
        }
      }
      .gm_card_body{
        flex: 1;
        min-height: 54px;
        max-height: 300px;
        padding: 6px 6px 8px 6px;
        overflow: auto;
      }
      .gm_member{
        display: flex;
        align-items: center;
        padding: 5px 8px;
        border-radius: 6px;
        font-size: 13px;
        color: #303133;
        cursor: grab;
        transition: background-color .15s, box-shadow .15s;
        & + .gm_member{
          margin-top: 2px;
        }
        &:hover{
          background-color: #F5F9FF;
          .gm_grip{
            color: #409EFF;
          }
          .gm_member_del{
            color: #C0C4CC;
          }
        }
        &:active{
          cursor: grabbing;
        }
        &.is-dragging{
          opacity: .45;
          background-color: #ECF5FF;
          box-shadow: inset 0 0 0 1px #B3D8FF;
        }
        &.is-drop-target{
          box-shadow: inset 0 2px 0 #409EFF;
        }
        .gm_grip{
          flex: none;
          width: 12px;
          text-align: center;
          color: #DCDFE6;
          line-height: 1;
          transition: color .15s;
          i{
            font-size: 13px;
            vertical-align: middle;
          }
        }
        .gm_avatar{
          flex: none;
          width: 22px;
          height: 22px;
          line-height: 22px;
          margin: 0 8px 0 3px;
          border-radius: 50%;
          text-align: center;
          font-size: 12px;
          color: #ffffff;
          &.c0{ background-color: #5B8FF9; }
          &.c1{ background-color: #35B98A; }
          &.c2{ background-color: #E8A33D; }
          &.c3{ background-color: #6C8AE4; }
          &.c4{ background-color: #9B7BE0; }
          &.c5{ background-color: #E8785A; }
        }
        .gm_member_name{
          flex: 1;
          min-width: 0;
          margin-right: 6px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .gm_member_cls{
          flex: none;
          width: 68px;
          padding: 0 2px;
          box-sizing: border-box;
          text-align: center;
          font-size: 12px;
          line-height: 18px;
          color: #7A8BA6;
          background-color: #F2F5FA;
          border-radius: 4px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .gm_member_star{
          flex: none;
          width: 16px;
          margin-left: 4px;
          text-align: center;
          color: #DCDFE6;
          cursor: pointer;
          line-height: 1;
          transition: color .15s;
          &:hover{
            color: #E6A23C;
          }
          &.is-leader{
            color: #E6A23C;
          }
          i{
            font-size: 14px;
          }
        }
        .gm_member_del{
          flex: none;
          width: 12px;
          margin-left: 4px;
          text-align: center;
          color: transparent;
          cursor: pointer;
          line-height: 1;
          transition: color .15s;
          &:hover{
            color: #F56C6C;
          }
          i{
            font-size: 12px;
          }
        }
      }
      .gm_card_empty{
        margin: 0;
        padding: 26px 0;
        text-align: center;
        font-size: 12px;
        color: #C0C4CC;
        border: 1px dashed #EBEEF5;
        border-radius: 6px;
      }
      &:nth-child(6n+1) .gm_num_badge{ background-color: #409EFF; }
      &:nth-child(6n+2) .gm_num_badge{ background-color: #2BB3A3; }
      &:nth-child(6n+3) .gm_num_badge{ background-color: #E6A23C; }
      &:nth-child(6n+4) .gm_num_badge{ background-color: #6C8AE4; }
      &:nth-child(6n+5) .gm_num_badge{ background-color: #B37FEB; }
      &:nth-child(6n+6) .gm_num_badge{ background-color: #F08C5A; }
    }
    .gm_add_card{
      min-height: 120px;
      border: 1px dashed #D3DCE6;
      border-radius: 8px;
      background-color: rgba(255, 255, 255, 0.6);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #909399;
      font-size: 13px;
      cursor: pointer;
      transition: border-color .18s, color .18s, background-color .18s, box-shadow .18s;
      i{
        font-size: 20px;
        margin-bottom: 8px;
      }
      &:hover{
        border-color: #409EFF;
        color: #409EFF;
        background-color: #F5FAFF;
        box-shadow: 0 4px 12px rgba(64, 158, 255, 0.12);
      }
    }
    .gm_dlg_foot{
      display: flex;
      align-items: center;
      justify-content: space-between;
      .gm_dirty{
        font-size: 12px;
        color: #909399;
        i{
          margin-right: 4px;
        }
        &.is-dirty{
          color: #E6A23C;
        }
      }
      .gm_dlg_btns{
        display: flex;
        align-items: center;
      }
    }
    @media screen and (max-width: 1200px){
      .gm_grid{
        grid-template-columns: repeat(3, minmax(0, 1fr));
      }
    }
    @media screen and (max-width: 900px){
      .gm_grid{
        grid-template-columns: repeat(2, minmax(0, 1fr));
      }
    }
    .gm_td_empty{
      color: #C0C4CC;
    }


  }

</style>



// WEBPACK FOOTER //
// src/pages/Teacher/components/classInfo.vue